import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Avatar, BookmarkOutline, CogOutline, LogoutOutline, QuestionMarkCircleAltOutline, rem, VStack } from '@bonusly/design-system';
import { useCurrentUser } from '@bonusly/who-am-i';

import { IconAndTextContent } from './icon-and-text-content';
import { NotificationMenuItem } from './notification';
import { ThemeMenuItem } from './theme-menu-item';
import { UserNavDivider } from './user-nav-divider';
import { UserNavLink } from './user-nav-link';
import { UserNavLinkExternal } from './user-nav-link-external';

interface UserMobileNavMenuProps {
	onOpenNotifications: () => void;
}

export const UserMobileNavMenu: FC<UserMobileNavMenuProps> = ({ onOpenNotifications }) => {
	const { t } = useTranslation('navigation');
	const user = useCurrentUser();

	return (
		<VStack align="stretch" spacing={1}>
			{/* VIEW PROFILE */}
			<UserNavLink to={`/company/users/${user.id}`} isRecognizeRoute isExpanded data-testid="mobile-nav-view-profile">
				<IconAndTextContent
					icon={<Avatar name={user.display_name} src={user.profile_pic_url} h={rem(24)} w={rem(24)} fontSize={1} />}
					label={t('user_menu.view_profile')}
					isExpanded
				/>
			</UserNavLink>

			{/* PROFILE SETTINGS */}
			<UserNavLink to="/users/edit" isRecognizeRoute isExpanded data-testid="mobile-nav-profile-settings">
				<IconAndTextContent icon={<CogOutline size="md" />} label={t('user_menu.profile_settings')} isExpanded />
			</UserNavLink>

			{/* BOOKMARKS */}
			<UserNavLink to="/bookmark" isExpanded data-testid="mobile-nav-bookmarks">
				<IconAndTextContent icon={<BookmarkOutline size="md" />} label={t('user_menu.bookmarks')} isExpanded />
			</UserNavLink>

			{/* NOTIFICATIONS */}
			<NotificationMenuItem isExpanded onClick={onOpenNotifications} />

			<UserNavDivider />

			{/* THEME */}
			<ThemeMenuItem isExpanded />

			{/* HELP CENTER */}
			<UserNavLinkExternal href="https://help.bonus.ly/en/" data-testid="mobile-nav-help-center">
				<IconAndTextContent icon={<QuestionMarkCircleAltOutline size="md" />} label={t('user_menu.help')} isExpanded />
			</UserNavLinkExternal>

			{/* LOG OUT */}
			<UserNavLink to="/users/sign_out" isRecognizeRoute isExpanded data-testid="mobile-nav-logout">
				<IconAndTextContent icon={<LogoutOutline size="md" />} label={t('user_menu.log_out')} isExpanded />
			</UserNavLink>
		</VStack>
	);
};
